import React from "react";

import * as english from "./english.js";
import * as estonian from "./estonian.js";

export const LANGUAGE_OPTIONS = [
    { code: "en", label: "EN", name: "English" },
    { code: "et", label: "ET", name: "Eesti" }
];

const PACKS = {
    en: english,
    et: estonian
};

const STORAGE_KEY = "uiLanguage";

const readStoredCode = () => {
    if (typeof window === "undefined") return "en";
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return "en";
        const parsed = JSON.parse(raw);
        return PACKS[parsed] ? parsed : "en";
    } catch {
        return "en";
    }
};

let currentCode = readStoredCode();

export const LanguageContext = React.createContext({
    language: currentCode,
    setLanguage: () => {}
});

/** Sync module-level language (for non-React helpers like snackbars). */
export const applyLanguageCode = (code) => {
    if (!PACKS[code]) return;
    currentCode = code;
    if (typeof document !== "undefined") {
        document.documentElement.lang = code;
        const pack = PACKS[code] || english;
        if (pack.WEBSITE_NAME) {
            document.title = pack.WEBSITE_NAME;
        }
    }
};

applyLanguageCode(currentCode);

export const getLanguageCode = () => currentCode;

/** Static pack for the active language (imperative callers). */
export const getLanguage = () => PACKS[currentCode] || english;

/** Reactive language pack for components. */
export const useLanguage = () => {
    const { language } = React.useContext(LanguageContext);
    return PACKS[language] || english;
};
